import { DynInputProps } from ".."
import { DatePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";

export default function DynDate({
    spec,
    field,
    getFieldState
}: DynInputProps) {

    const { onChange, value } = field.field

    return (
        <DatePicker
            sx={{ width: '100%', mt: 1, mb: 2 }}
            label={spec.label}
            onChange={(data: Moment | null) => data && onChange(data.format('DD/MM/YYYY'))}
            slotProps={{
                textField: {
                    required: spec.required,
                    error: getFieldState(spec.name).invalid,
                    helperText: getFieldState(spec.name).error?.message || ""
                },
            }}
        />
    )
}